<template>
    <div class="flex justify-between mb-4">
        <div class="w-64 mr-8">
            <input type="hidden" :name="`areas[${area.id}][id]`" :value="area.id">
            <template v-if="area.id">
                {{ area.name }}
            </template>
            <TextInput
                v-else
                v-model="area.name"
                name="name"
                v-validate="'required'"
                type="text"
                :error="formErrors.first('name')"
            />
        </div>
        <div class="flex-1 mr-8">
            <TextInput
                v-model="area.square_meter"
                name="square_meter"
                v-validate="'required'"
                type="text"
                :error="formErrors.first('square_meter')"
                @input="updateSquareMeter(area)"
            />
        </div>
        <div class="w-24">
            <button @click.prevent="$emit('remove', area)"><Icon name="x-circle" /></button>
        </div>
    </div>
</template>

<script>
    import TextInput from '@/components/inputs/TextInput';

    export default {
        name: 'OrderArea',
        components: {
            TextInput,
        },
        props: {
            area: {
                type: Object,
                required: true,
            },
            index: {
                type: Number,
                required: true,
            },
        },
        methods: {
            updateSquareMeter(area) {
                area.square_meter = area.square_meter.replace(/,/g, '.');
            },
        },
    };
</script>
